import { DirectLinkIntent, PROGRAM_TAXONOMY } from './customerProgram'
import { TREATMENT_OPTIONS } from './treatmentOptions'
import { ProgramNames } from '../../../models/programs/Programs'
import { getDirectBookingParamsByProgramName } from '../../programConfigs/programHelpers'
import { DirectLinkSource, DirectPathBookingApplinkParams } from '../../searchForCare/constants'

export const THERAPY_PARAMS: DirectPathBookingApplinkParams = {
  ...getDirectBookingParamsByProgramName(ProgramNames.BlendedCareTherapy)!,
}

export const COACHING_PARAMS: DirectPathBookingApplinkParams = {
  directPath: 'true',
  ...getDirectBookingParamsByProgramName(ProgramNames.Coaching)!,
}

export const PARENTING_PARAMS: DirectPathBookingApplinkParams = {
  directPath: 'true',
  ...getDirectBookingParamsByProgramName(ProgramNames.CoachingForParents)!,
  directLinkIntent: DirectLinkIntent.PARENTING,
}

export const MEDS_PARAMS = {
  ...getDirectBookingParamsByProgramName(ProgramNames.MedicationManagement)!,
}

export const OUTPATIENT_MEDS_PARAMS: DirectPathBookingApplinkParams = {
  ...MEDS_PARAMS,
  directLinkIntent: DirectLinkIntent.OUTPATIENT_MEDS,
}

export const DA_MEDS_PARAMS: DirectPathBookingApplinkParams = {
  ...getDirectBookingParamsByProgramName(ProgramNames.DIRECT_ACCESS_MEDS)!,
}

export const AUD_PARAMS: DirectPathBookingApplinkParams = {
  ...getDirectBookingParamsByProgramName(ProgramNames.AlcoholUseDisorderTherapy)!,
  directLinkIntent: DirectLinkIntent.AUD,
}

export const DBTT_PARAMS: DirectPathBookingApplinkParams = {
  ...getDirectBookingParamsByProgramName(ProgramNames.DialecticalBehaviorTherapyTeens)!,
  directLinkIntent: DirectLinkIntent.DBTT,
}

export const COUPLES_PARAMS: DirectPathBookingApplinkParams = {
  directPath: 'true',
  ...getDirectBookingParamsByProgramName(ProgramNames.DirectAccessCouplesTherapy)!,
}

export const FAMILY_PARAMS: DirectPathBookingApplinkParams = {
  directPath: 'true',
  ...getDirectBookingParamsByProgramName(ProgramNames.DirectAccessFamilyTherapy)!,
}

export const createOnsiteTherapyParams = ({
  customerName,
}: {
  customerName: string
}): DirectPathBookingApplinkParams => ({
  directPath: 'true',
  clientele: PROGRAM_TAXONOMY.clientele.individual,
  treatment: PROGRAM_TAXONOMY.treatment.therapy,
  offering: PROGRAM_TAXONOMY.offering.default,
  partner: customerName,
  treatmentOption: TREATMENT_OPTIONS.INDIVIDUAL_THERAPY,
})

export const THERAPY_PARAMS_FROM_HIGH_RISK_MODAL: DirectPathBookingApplinkParams = {
  directPath: 'true',
  ...getDirectBookingParamsByProgramName(ProgramNames.BlendedCareTherapy)!,
  directLinkIntent: DirectLinkIntent.DIRECT_LINK_INTENT_HIGH_RISK,
  directLinkSource: DirectLinkSource.DIRECT_BOOKING_HIGH_RISK_MODAL,
}

export const THERAPY_PARAMS_FROM_CUSTOM_PREFS_HIGH_RISK_REDIRECT: DirectPathBookingApplinkParams = {
  directPath: 'true',
  ...getDirectBookingParamsByProgramName(ProgramNames.BlendedCareTherapy)!,
  directLinkIntent: DirectLinkIntent.DIRECT_LINK_INTENT_HIGH_RISK,
  directLinkSource: DirectLinkSource.CUSTOM_PREFS_HIGH_RISK_REDIRECT,
}
